import { CHAT_ASSISTANT_PADDING_HORIZONTAL } from '@fruitful/agent-ui';
import React from 'react';
import { YStack } from 'smoothie';

import { useTypewriter } from '../../hooks/useTypewriter';
import { SimpleMarkdown } from '../SimpleMarkdown';
import { StaticFruitfulIcon } from './StaticFruitfulIcon';

export {
    isContentAlreadyTyped,
    markTextAsTyped,
} from '../../hooks/useTypewriter';

interface AssistantMessageProps {
    content: string;
    showLogoIcon?: boolean;
    isError?: boolean;
    skipTypingAnimation?: boolean;
    isStreaming?: boolean;
    onTypingComplete?: () => void;
}

export const AssistantMessage = ({
    content,
    showLogoIcon = true,
    isError = false,
    skipTypingAnimation = false,
    isStreaming = false,
    onTypingComplete,
}: AssistantMessageProps) => {
    const textColor = isError ? '$red1100' : '$black';
    const { visibleText } = useTypewriter({
        text: content,
        skipAnimation: skipTypingAnimation,
        isStreaming,
        onComplete: onTypingComplete,
    });

    return (
        <YStack paddingHorizontal={CHAT_ASSISTANT_PADDING_HORIZONTAL} gap="$3">
            <SimpleMarkdown content={visibleText} color={textColor} />
            {showLogoIcon ? <StaticFruitfulIcon /> : null}
        </YStack>
    );
};
